'use strict';
require('intl');

exports.da = function () {
	require('intl/locale-data/jsonp/da-DK.js');
	return require('./lib/da.json');
};

exports.de = function () {
	require('intl/locale-data/jsonp/de-AT.js');
	require('intl/locale-data/jsonp/de-DE.js');
	return require('./lib/de.json');
};

exports.en = function () {
	require('intl/locale-data/jsonp/en-GB.js');
	return require('./lib/en.json');
};

exports.fi = function () {
	require('intl/locale-data/jsonp/fi-FI.js');
	return require('./lib/fi.json');
};

exports.sv = function () {
	require('intl/locale-data/jsonp/sv-SE.js');
	return require('./lib/sv.json');
};

exports.no = function () {
	require('intl/locale-data/jsonp/nb-NO.js');
	require('intl/locale-data/jsonp/nn-NO.js');
	return require('./lib/no.json');
};
